import BaseApi from './base.api'
import ApiService from '@services/api.service'

export default {
    ...BaseApi,
    ...{
        resource: 'schools',
        
        updateMeta( params = null) {
            return ApiService.post(`/${this.resource}/${params.id}/meta`, params)
        },
        syncWithTeams(schoolId) {
            return ApiService.post(`/${this.resource}/${schoolId}/teams/sync`)
        },

        resyncWithTeams(schoolId) {
            return ApiService.post(`/${this.resource}/${schoolId}/teams/resync`)
        },

        getTeamsSyncStatus(schoolId) {
            return ApiService.get(`/${this.resource}/${schoolId}/teams/sync-status`)
        },

         getAllTeamsSyncStatuses(ids) {
            return ApiService.post(`/schools/teams/sync-statuses`, { ids });
        }
        
    }
}
